import { render, staticRenderFns } from "./indexCourse.vue?vue&type=template&id=3ada848f&scoped=true&"
import script from "./indexCourse.vue?vue&type=script&lang=js&"
export * from "./indexCourse.vue?vue&type=script&lang=js&"
import style0 from "./indexCourse.vue?vue&type=style&index=0&id=3ada848f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada848f",
  null
  
)

export default component.exports